import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type TrialCloseChecklistItemRecord = {
  description: string;
  count: number;
  blocking: boolean;
  details: string[];
};

export type TrialCloseResultRecord = {
  checklistItems: TrialCloseChecklistItemRecord[];
};

export const inventoryPeriodTrialCloseQueryAtom = createQueryAtomFactory(
  'inventory.inventoryPeriodTrialClose',
  (params: { id: string }) => ({
    inventoryPeriodTrialClose: {
      __args: {
        periodId: params.id,
      },
      checklistItems: {
        description: true,
        count: true,
        blocking: true,
        details: true,
      },
    },
  }),
  {
    select: (data): TrialCloseResultRecord | null =>
      data?.inventoryPeriodTrialClose ?? null,
  },
);
